const LiveChat = (): void => {
  const startChatButton: any = document.querySelector("#startChatButton");
  if (startChatButton) {
    startChatButton.addEventListener("click", function () {
      window["pushDigitalData"](
        {
          event: "_liveChatInteraction",
          LiveChatFlag: "Interaction",
          nonInteraction: true,
        },
        true
      );
    });
  }
};
LiveChat();
